import React from 'react';
import PropTypes from 'prop-types';
import { COLORS } from './theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBan, faBuilding, faCalendarAlt, faCalendarRange, faCashRegister, faChartBar, faCheckCircle, faChevronDown, faCircleNotch, faCircleUser, faCircleXmark, 
  faClone, faCodeBranch, faCrosshairs, faDatabase, faDollarSign, faDrawPolygon, faEdit, faEnvelope, faExclamation, faFileCsv, faFilePdf, faFileSignature, 
  faGear, faHourglass, faKey, faListCheck, faLocationDot, faMapMarkedAlt, faMasksTheater, faNewspaper, faPiggyBank, faPlay, faReceipt, faRightFromBracket, 
  faRoad, faRobot, faRoute, faSave, faSearch, faStore, faSync, faSyncAlt, faTimeline, faTimes, faTrashAlt, faTurnDownRight, faUpload, faUserLock, faUsers, 
  faVial, faWrench, faHouse, faUser, faCode, faCaretRight, faCaretLeft, faHouseUser,
  faWifi, faIcons, faThumbsUp
} from '@fortawesome/pro-solid-svg-icons'
import { faAndroid, faAppStore, faApple, faAws, faGoogle, faReact, faUnity } from '@fortawesome/free-brands-svg-icons';
import {
  faCheckSquare, faCircleMinus, faCirclePlus, faEmptySet, faFile, faInfoCircle, faMobile, faSigma, faTimesCircle, faUserCheck,
  faCodeBranch as farCodeBranch, faPenRuler, faBuilding as farBuilding, faFaceSmileWink, faPersonDigging, 
  faTag
} from '@fortawesome/pro-regular-svg-icons';
import { faBuildingColumns, faCirclePlus as falCirclePlus, faCircleMinus as falCircleMinus, faFileExport, faMapLocation, faBracketsCurly, faTerminal, faEyeDropper, faSignalStream, faEye } from '@fortawesome/pro-light-svg-icons';
import Flutter from "../../assets/images/docs/flutter.svg";
import Cordova from "../../assets/images/docs/cordova.svg";

function Icon(props) {
  function icon() {
    switch (props.icon) {
      case 'key':
        return faKey;
      case 'check-square':
        return faCheckSquare;
      case 'home':
        return faHouse;
      case 'polygon':
        return faDrawPolygon;
      case 'aws':
        return faAws;
      case 'user':
        return faUser;
      case 'organisation':
        return faBuildingColumns;
      case 'plus':
        return faCirclePlus;
      case 'minus':
        return faCircleMinus;
      case 'plusLight':
        return falCirclePlus;
      case 'minusLight':
        return falCircleMinus;
      case 'users':
        return faUsers;
      case 'users-solid':
        return faUsers;
      case 'privacy':
        return faEye;
      case 'edit':
        return faEdit;
      case 'retry':
        return faSyncAlt;
      case 'save':
        return faSave;
      case 'cancel':
        return faBan;
      case 'code':
        return faCode;
      case 'caret-right':
        return faCaretRight;
      case 'caret-left':
        return faCaretLeft;
      case 'calendar':
        return faCalendarAlt;
      case 'location':
        return faLocationDot;
      case 'visit':
        return faMapMarkedAlt;
      case 'trace':
        return faRoad;
      case 'geovisit':
        return faStore;
      case 'snapped_trace':
        return faRoute
      case 'wifi_event':
        return faWifi
      case 'beacon':
        return faTag
      case 'checkCircle':
        return faCheckCircle;
      case 'crossCircle':
        return faCircleXmark;
      case 'stream':
        return faSignalStream;
      case 'house':
        return faHouseUser;
      case 'work':
        return faBuilding;
      case 'target':
        return faCrosshairs;
      case 'file':
        return faFile;
      case 'upload':
        return faUpload;
      case 'csv':
        return faFileCsv;
      case 'close-circle':
        return faTimesCircle;
      case 'fileExport':
        return faFileExport;
      case 'sum':
        return faSigma;
      case 'mobile':
        return faMobile;
      case 'trash':
        return faTrashAlt;
      case 'play':
        return faPlay;
      case 'loading':
        return faCircleNotch; //Need to spin
      case 'chart':
        return faChartBar;
      case 'sync':
          return faSync;
      case 'admin':
        return faUserLock;
      case 'info':
        return faInfoCircle;
      case 'empty':
        return faEmptySet;
      case 'user-circle':
        return faCircleUser;
      case 'search':
        return faSearch
      case 'map-location':
        return faMapLocation
      case 'brackets':
        return faBracketsCurly
      case 'terminal':
        return faTerminal
			case 'configure':
				return faGear
			case 'branch':
				return faCodeBranch
			case 'revenue':
				return faDollarSign
			case 'unity':
				return faUnity
			case 'reactNative':
				return faReact
			case 'tcfv2Migration':
				return faFileSignature
      case 'consent':
        return faUserCheck
      case 'app':
        return faAppStore
      case 'exclamation':
        return faExclamation
      case 'audience':
        return faEyeDropper
      case 'version':
        return farCodeBranch
      case 'pdf':
        return faFilePdf
      case 'income':
        return faCashRegister
      case 'cost':
        return faReceipt
      case 'gross':
        return faPiggyBank
      case 'calendarRange':
        return faCalendarRange
      case 'listCheck':
        return faListCheck
      case 'arrowListElement':
        return faTurnDownRight
      case 'hourglass':
        return faHourglass
      case 'times':
        return faTimes;
      case 'vial':
        return faVial
      case 'layout':
        return faPenRuler
      case 'vendor':
        return farBuilding
      case 'ios':
        return faApple
      case 'android':
        return faAndroid
      case 'mask':
        return faMasksTheater
      case 'publishers':
        return faNewspaper
      case 'database':
        return faDatabase
      case 'pakito':
        return faFaceSmileWink
      case 'wrench':
        return faWrench
      case 'service':
        return faRightFromBracket
      case 'clone':
        return faClone
      case 'api':
        return faKey
      case 'maintenance':
        return faPersonDigging
      case 'send':
        return faEnvelope
      case 'publisher':
        return faIcons
      case 'ban':
        return faBan
      case 'allow':
        return faThumbsUp
      case 'timeline':
        return faTimeline
      default:
        return '';
    }
  }

  const iconSVG = () => {
    switch (props.icon) {
      case 'flutter':
        return Flutter
      case 'cordova':
        return Cordova
      default:
        return null
    }
  }


  const isSVG = () => {
    return !!iconSVG()
  }

	const variantStyle = () => {
    switch (props.variant) {
      case 'primary':
        return {color: COLORS.primary}
      case 'danger':
        return {color: "#dc3545"}
      case 'secondary':
        return {color: COLORS.midGrey}
    }
  }
  const style = {
    ...props.style,
    ...variantStyle()
  }

  if (isSVG()) {
    return (<>
      <img src={iconSVG()} className='svg-inline--fa' alt={props.text}/> {props.text}
    </>)
  }

  return (
    <React.Fragment>
      <FontAwesomeIcon icon={icon()}  style={style} size={props.size}/>  {props.text}
    </React.Fragment>
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.node,
  size: PropTypes.string,
  style: PropTypes.object
}

 export default Icon;
